import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import { getSelectOptions } from 'bundles/apex/pipeline/settings/helpers';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export default function CustomColumn({
  allOptions,
  availableOptions,
  canDelete = false,
  columnIndex,
  value,
  onChange,
  onDelete,
}) {
  return (
    <div className="d-flex align-items-center gap-2">
      <ManagedFormGroup
        label={`Custom Column ${columnIndex + 1}`}
        name={`column${columnIndex + 1}`}
        type="select"
        value={value}
        onValueChange={value => onChange(columnIndex, value)}
      >
        {getSelectOptions(allOptions, availableOptions, value).map(
          ({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ),
        )}
      </ManagedFormGroup>
      {canDelete && (
        <div className="mt-6 clickable" name="delete-icon" onClick={onDelete}>
          <FontAwesomeIcon icon={faTrash} />
        </div>
      )}
    </div>
  );
}

CustomColumn.propTypes = {
  allOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  availableOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  canDelete: PropTypes.bool,
  columnIndex: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};
